import { assets, doctors } from "../../assets/assets";

export interface Testimonial {
    id: string;
    name: string;
    role: string;
    clinicName: string;
    avatar: string;
    quote: string;
}

export const TESTIMONIALS: Testimonial[] = [
    {
        id: "anita-balakrishna",
        name: "Dr. Anita Balakrishna",
        role: "Gynaecologist",
        clinicName: "Bengaluru",
        avatar: assets.dr_anita,
        quote: "Eikos provided the perfect solution for my clinic. Integrating WhatsApp and AI into our booking system has significantly automated our front desk workflow."
    },
    {
        id: "prathap-uramkar",
        name: "Dr. Prathap Uramkar",
        role: "Orthopaedic Surgeon",
        clinicName: "Bengaluru",
        avatar: assets.dr_prathap,
        quote: "I like that I can manage appointments from my WhatsApp. Whether I’m between consultations or at home, my schedule is always updated."
    },
    {
        id: "teena-bannihatti",
        name: "Dr. Teena Bannihatti",
        role: "Gynaecologist",
        clinicName: "Bengaluru",
        avatar: assets.dr_teena,
        quote: "Eikos has made managing my clinic so much easier. I can update my schedule, confirm appointments, and handle cancellations, all on WhatsApp. No extra apps, no learning curve."
    },
    {
        id: "balasubramanian",
        name: "Dr. Balasubramanian",
        role: "Orthopaedic Surgeon",
        clinicName: "Bengaluru",
        avatar: assets.placeholder_avatar_image,
        quote: "Eikos handles the small but important things like confirmations, reminders, follow-ups, so I can focus fully on my patients."
    }
];
